import {
  Autocomplete,
  Chip,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import Text from "../../utils/commonComponent/Custom/text";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { getPermissions } from "../rbac/hasAccess";
import { useParams } from "react-router-dom";
import {
  fetchDatasheetDetails,
  fetchRemarks,
  fetchSettings,
  fetchUnits,
  fetchUsers,
} from "./fetchHandler";
import { parseDepth } from "../../utils/commonComponent/parse";
import { AddButton } from "../../utils/commonComponent/Custom/Button";
import { handleSubmit, processDatasheetReadings, sendForApproval } from "./submitHandler";
import ObservedReadings from "./ObservedReadings/ObservedReadings";
import { initialState } from "./datasheet.state";
import { useCreateReducer } from "../../utils/commonComponent/hooks/useCreateReducer";
import { DatasheetContext } from "./datasheet.context";
import "./datasheet.css";
import { ClassicTableDatasheet } from "../../utils/commonComponent/Styles";
import moment from "moment";
import {
  accuracyFormat,
  parseRange,
} from "../../utils/commonComponent/accuracyandlcandrangesshow";
import DatasheetImages from "./datasheetImages";
import InwardTestsViewer from "./InwardTestsViewer";
import ObservationWitnessHistory from "./ObservationWitnessHistory";

const DatasheetForm = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const [datasheetDetails1, setDatasheetDetails] = useState({});
  const [reamrksList, setReamrksList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [witnessDetails, setWitnessDetails] = useState({
    newRows: [],
    deletedIds: [],
  });

  const datasheetContextValue = useContext(DatasheetContext);
  const {
    state: {
      srfDetails,
      datasheetDetails,
      certificateDetails,
      standardMasterDetails,
      indicators,
      settings,
      instrumentDetails,
      currentOperationState,
      referenceData,
      DatasheetReadingsAdditionalInfo,
      staticTables,
      Remarks,
      staticReadingRows,
      standardMasterArray,
      selectedStandardIds,
      selectedStandardMasters,
      fileAttachment,
      inwardTestsList,
      additionalTestDetails
    },
    dispatch,
  } = datasheetContextValue;

  const updateInputObject = (key, value) => {
    setDatasheetDetails((prev) => ({ ...prev, [key]: value }));
  };

  const updateSelectedStandardMasters = (selectedStandardIds) => {
    let _selectedStandardIds = [];

    if (Array.isArray(selectedStandardIds)) {
      _selectedStandardIds = selectedStandardIds
        .map((id) => Number(id))
        .filter((id) => id > 0);
    } else if (typeof selectedStandardIds === "string") {
      _selectedStandardIds = selectedStandardIds
        .split(",")
        .map((id) => Number(id))
        .filter((id) => id > 0);
    }

    if (!filteredOptions || filteredOptions.length === 0) return;

    let tempSelectedStandardMasters = [];
    _selectedStandardIds.forEach((id) => {
      let standardMaster = filteredOptions.find(
        (standard) => standard.id == id
      );
      if (standardMaster) tempSelectedStandardMasters.push(standardMaster);
    });

    dispatch({
      field: "selectedStandardMasters",
      value: [...tempSelectedStandardMasters],
    });
  };

  // 🔹 Update filteredOptions whenever dependencies change
  useEffect(() => {
    if (
      !standardMasterArray?.length ||
      !datasheetDetails1?.observationSheet_startTestingDate
    )
      return;

    const filtered = standardMasterArray
      ?.filter((row) =>
        moment(datasheetDetails1?.observationSheet_startTestingDate).isBetween(
          row.version_calDate,
          row.version_dueDate,
          null,
          "[]"
        )
      )
      ?.reduce((acc, row) => {
        if (!acc[row.equipmentId] || row.version_id > acc[row.equipmentId].version_id) {
          acc[row.equipmentId] = row;
        }
        return acc;
      }, {});

    setFilteredOptions(Object.values(filtered || {}));
  }, [
    standardMasterArray,
    datasheetDetails1?.observationSheet_startTestingDate,
  ]);

  useEffect(() => {
    updateSelectedStandardMasters(selectedStandardIds);
  }, [selectedStandardIds, filteredOptions]);

  useEffect(() => {
    fetchDatasheetDetails(params, setDatasheetDetails, dispatch);
    fetchRemarks(setReamrksList);
  }, [params]);

  useEffect(() => {
    fetchUsers().then((users) => {
      setUserList(users);
    });
    fetchSettings(dispatch);
  }, []);

  useEffect(() => {
    if (datasheetDetails?.materialScope_discplineId > 0) {
      // fetchDisciplineDetails(datasheetDetails.materialScope_discplineId, dispatch);
      fetchUnits(datasheetDetails.materialScope_discplineId, dispatch);
    }
  }, [datasheetDetails.materialScope_discplineId]);

  return (
    <div>
      <Text align="center" variant="h2" bold>
        ObservationSheet of {datasheetDetails1?.materialTestings_testName}
      </Text>
      <br />
      <div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <TextField
            id="outlined-basic"
            label="Customer Name"
            size="small"
            value={datasheetDetails1?.jobRegister_clientName || ""}
            fullWidth
            variant="outlined"
            disabled
          />
          <TextField
            id="outlined-basic"
            label="Job No."
            size="small"
            value={datasheetDetails1?.jobRegister_jobNumber || ""}
            fullWidth
            variant="outlined"
            disabled
          />
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  inputProps: { readOnly: true },
                },
              }}
              label="Job Date"
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              value={
                datasheetDetails1?.jobRegister_jobDate
                  ? new Date(datasheetDetails1?.jobRegister_jobDate)
                  : null
              }
              disabled
            />
          </LocalizationProvider>

          <TextField
            id="outlined-basic"
            label="Lab Reference No."
            size="small"
            value={datasheetDetails1?.inward_labReferenceNo || ""}
            fullWidth
            variant="outlined"
            disabled
          />
          <TextField
            id="outlined-basic"
            label="Test No."
            size="small"
            value={datasheetDetails1?.observationSheet_testNumber || ""}
            fullWidth
            variant="outlined"
            disabled
          />

          <TextField
            id="outlined-basic"
            label="Report No."
            size="small"
            value={datasheetDetails1?.certificate_reportNumber || ""}
            fullWidth
            variant="outlined"
            disabled
            className="col-start-1"
          />
          <TextField
            id="outlined-basic"
            label="ULR No."
            size="small"
            value={datasheetDetails1?.observationSheet_ulrNumber || ""}
            fullWidth
            variant="outlined"
            disabled
            // className="col-span-1 sm:col-span-2 md:col-span-2 lg:col-span-2"
          />
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  required: true,
                  inputProps: { readOnly: true },
                  onKeyDown: (e) => {
                    e.preventDefault();
                  },
                  error: !datasheetDetails1?.observationSheet_startTestingDate,
                  helperText:
                    !datasheetDetails1?.observationSheet_startTestingDate
                      ? "Start Date is required"
                      : "",
                },
              }}
              maxDate={new Date()}
              minDate={permissions?.backdateShow ? null : new Date()}
              label="Start Date Testing"
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              value={
                datasheetDetails1?.observationSheet_startTestingDate
                  ? new Date(
                      datasheetDetails1.observationSheet_startTestingDate
                    )
                  : null
              }
              onChange={(newDate) =>
                updateInputObject("observationSheet_startTestingDate", newDate)
              }
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  inputProps: { readOnly: true },
                  onKeyDown: (e) => {
                    e.preventDefault();
                  },
                  required: true,
                  error: !datasheetDetails1?.observationSheet_endTestingDate,
                  helperText:
                    !datasheetDetails1?.observationSheet_endTestingDate
                      ? "End Date is required"
                      : "",
                },
              }}
              label="End Date Testing"
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              minDate={
                datasheetDetails1?.observationSheet_startTestingDate
                  ? new Date(
                      datasheetDetails1.observationSheet_startTestingDate
                    )
                  : null
              }
              value={
                datasheetDetails1?.observationSheet_endTestingDate
                  ? new Date(datasheetDetails1.observationSheet_endTestingDate)
                  : null
              }
              onChange={(newDate) =>
                updateInputObject("observationSheet_endTestingDate", newDate)
              }
            />
          </LocalizationProvider>
        </div>
        <div style={{ padding: "20px" }}>
        </div>
              
        <Divider sx={{ my: 2 }}>
          <Chip
            label="Details of Tests"
            variant="outlined"
            sx={{ fontSize: "16px", fontWeight: "bold" }}
          />
        </Divider>
        
        <br/>

        <InwardTestsViewer
          inwardTestsList={inwardTestsList}
          datasheetDetails1={datasheetDetails1}
          updateInputObject={updateInputObject}
          additionalTestDetails={additionalTestDetails}
        />

        <Divider sx={{ my: 2 }}>
          <Chip
            label={`Details of Master EQP Used For Testing`}
            variant="outlined"
            sx={{ fontSize: "16px", fontWeight: "bold" }}
          />
        </Divider>

        <div>

          {!props.isPrinting && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                margin: "auto",
                marginBottom: "5px",
              }}
            >
              <Autocomplete
                multiple
                id="outlined-basic"
                size="small"
                className="Listinputcss"
                style={{ minWidth: "350px" }}
                disableCloseOnSelect
                options={filteredOptions}
                value={
                  filteredOptions?.filter((ele) =>
                    selectedStandardIds
                      ?.split(",")
                      ?.map(Number)
                      ?.includes(ele.id)
                  ) || []
                }
                getOptionLabel={(option) =>
                  `${option.equipmentId} : ${option.equipmentName}` || ""
                }
                renderInput={(params) => (
                  <TextField {...params} label="Master EQP Selection" />
                )}
                onChange={(event, value) =>
                  dispatch({
                    field: "selectedStandardIds",
                    value: value.map((option) => option.id).join(","),
                  })
                }
              />
            </div>
          )}
        </div>

        <br />

        {selectedStandardMasters.length > 0 && (
          <div style={{ width: "100%", overflow: "auto" }}>
            <ClassicTableDatasheet>
              <Table sx={{ minWidth: 660 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {selectedStandardMasters &&
                      selectedStandardMasters.length > 0 && (
                        <TableCell>Sr. No.</TableCell>
                      )}
                    {selectedStandardMasters &&
                      selectedStandardMasters.some(
                        (row) => row.equipmentName
                      ) && <TableCell>Name of Standard</TableCell>}
                    {selectedStandardMasters &&
                      selectedStandardMasters.some(
                        (row) => row?.equipmentId || row.serialNo
                      ) && <TableCell>ID / Sr. No.</TableCell>}
                    {selectedStandardMasters &&
                      selectedStandardMasters.some(
                        (row) => row.masterrange
                      ) && <TableCell>Range</TableCell>}
                    {selectedStandardMasters &&
                      selectedStandardMasters.some(
                        (row) => row.masteraccuracy
                      ) && <TableCell>Accuracy</TableCell>}
                    {selectedStandardMasters &&
                      selectedStandardMasters.some(
                        (row) => row.masterleastcount
                      ) && <TableCell>Least Count</TableCell>}
                    {!props.isPrinting &&
                      selectedStandardMasters &&
                      selectedStandardMasters.some((row) => row.make) && (
                        <TableCell>Make/Model</TableCell>
                      )}
                    {selectedStandardMasters &&
                      selectedStandardMasters.some(
                        (row) => row.certificateNumber
                      ) && <TableCell>Certificate No.</TableCell>}
                    {!props.isPrinting &&
                      selectedStandardMasters &&
                      selectedStandardMasters.some(
                        (row) => row.traceability
                      ) && <TableCell>Calibration Agency</TableCell>}
                    {selectedStandardMasters &&
                      selectedStandardMasters.some(
                        (row) => row.version_calDate
                      ) && <TableCell>Calibration Date</TableCell>}
                    {selectedStandardMasters &&
                      selectedStandardMasters.some(
                        (row) => row.version_dueDate
                      ) && <TableCell>Due Date</TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedStandardMasters &&
                    selectedStandardMasters?.map((row, index) => (
                      <TableRow key={"standard-row-" + index}>
                        {selectedStandardMasters.length > 0 && (
                          <TableCell>{index + 1}</TableCell>
                        )}
                        {selectedStandardMasters.some(
                          (row) => row.equipmentName
                        ) && (
                          <TableCell
                            style={{
                              color: `${
                                moment().isAfter(row?.version_dueDate)
                                  ? "red"
                                  : ""
                              }`,
                            }}
                          >
                            {row.equipmentName}
                          </TableCell>
                        )}
                        {selectedStandardMasters.some(
                          (row) => row.equipmentId || row.serialNo
                        ) && (
                          <TableCell>
                            {row.equipmentId && row.serialNo
                              ? `${row.equipmentId} / ${row.serialNo}`
                              : row.equipmentId || row.serialNo}
                          </TableCell>
                        )}
                        {selectedStandardMasters.some(
                          (row) => row.masterrange
                        ) && (
                          <TableCell>{parseRange(row.masterrange)}</TableCell>
                        )}
                        {selectedStandardMasters.some(
                          (row) => row.masteraccuracy
                        ) && (
                          <TableCell>
                            {accuracyFormat(row.masteraccuracy)}
                          </TableCell>
                        )}
                        {selectedStandardMasters.some(
                          (row) => row.masterleastcount
                        ) && (
                          <TableCell>
                            {parseRange(row.masterleastcount)}
                          </TableCell>
                        )}
                        {!props.isPrinting &&
                          selectedStandardMasters.some((row) => row.make) && (
                            <TableCell>{row.make}</TableCell>
                          )}
                        {selectedStandardMasters.some(
                          (row) => row.certificateNumber
                        ) && <TableCell>{row.certificateNumber}</TableCell>}
                        {!props.isPrinting &&
                          selectedStandardMasters.some(
                            (row) => row.traceability
                          ) && <TableCell>{row.traceability}</TableCell>}
                        {selectedStandardMasters.some(
                          (row) => row.version_calDate
                        ) && (
                          <TableCell>
                            {moment(row.version_calDate).format("DD/MM/YYYY")}
                          </TableCell>
                        )}
                        {selectedStandardMasters.some(
                          (row) => row.version_dueDate
                        ) && (
                          <TableCell>
                            {moment(row.version_dueDate).format("DD/MM/YYYY")}
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </ClassicTableDatasheet>
          </div>
        )}

        <br />

        <Divider sx={{ my: 1 }}>
          <Chip
            label={`Testing Results`}
            variant="outlined"
            sx={{ fontSize: "16px", fontWeight: "bold" }}
          />
        </Divider>

        <ObservedReadings
          datasheetId={params.id}
          isPrinting={false}
          setLoader={setLoader}
        />
        <br />
        <br />

        {settings?.["datasheetImages"] === "true" && (
          <div style={{ width: "60%" }}>
            <br />
            <DatasheetImages />
          </div>
        )}

        <Divider sx={{ my: 1 }}>
          <Chip
            label={`Remarks`}
            variant="outlined"
            sx={{ fontSize: "16px", fontWeight: "bold" }}
          />
        </Divider>

        <div className="w-[30%]">
          <Autocomplete
            size="small"
            id="combo-box-demo"
            options={reamrksList}
            getOptionLabel={(option) => option.label}
            onChange={(event, newValue) => {
              if (newValue) {
                updateInputObject("observationSheet_configuration", {
                  ...(datasheetDetails1?.observationSheet_configuration || {}),
                  remark: newValue.value,
                });
              }
            }}
            renderInput={(params) => (
              <TextField {...params} label="Choose Remark" />
            )}
          />
        </div>

        <div className="col-span-2">
          <TextareaAutosize
            aria-label="Remark Input"
            minRows={4}
            placeholder="Enter or edit remark here"
            className="border border-blue-500 mt-2 p-2 w-full focus:outline-none focus:ring-0"
            value={
              datasheetDetails1?.observationSheet_configuration?.remark || ""
            }
            onChange={(e) => {
              const config =
                datasheetDetails1?.observationSheet_configuration || {};
              updateInputObject("observationSheet_configuration", {
                ...config,
                remark: e.target.value,
              });
            }}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-5">
        <TextField
          id="outlined-lengthOfRock"
          label="Tested By"
          size="small"
          value={datasheetDetails1?.testedBy_userName || ""
            // userList.find(
            //   (u) => u.id == datasheetDetails1?.observationSheet_testedBy
            // )?.userName || "-"
          }
          fullWidth
          variant="outlined"
          disabled
        />
      </div>
      
      {settings?.["ObservationWitnessHistory"] === "true" && (
        <ObservationWitnessHistory
          observationSheetId={datasheetDetails1?.id}
          onWitnessChange={setWitnessDetails}
          permissions={permissions}
        />
      )}

      <br />
      <div className="flex items-center my-5 w-full">
      <div className="flex-1 flex justify-center gap-10">
        {(permissions.save || permissions.allAccess) &&
          props?.rolesInfo.currentRole?.id == 1 && (
            <>
              <AddButton
                id="btn-add-process"
                label="Process"
                disabled={datasheetDetails?.observationSheet_requestApproval == 1}
                onClick={async () => {
                  try {
                    // Step 1️⃣ — Call processDatasheetReadings first
                    const res = await processDatasheetReadings(datasheetContextValue);

                    // Step 2️⃣ — Dispatch result if available
                    if (res) {
                      dispatch({
                        field: "staticReadingRows",
                        value: [...res],
                      });
                    }

                    // Step 3️⃣ — After dispatch, call handleSubmit
                    await handleSubmit(
                      params,
                      datasheetDetails1,
                      staticReadingRows,
                      staticTables,
                      false,
                      selectedStandardIds,
                      fileAttachment,
                      witnessDetails
                    );
                  } catch (err) {
                    console.error("Error in Process flow:", err);
                  }
                }}
              />

              <AddButton
                id="btn-add-save"
                label="Save"
                disabled={datasheetDetails?.observationSheet_requestApproval == 1}
                onClick={() =>
                  handleSubmit(
                    params,
                    datasheetDetails1,
                    staticReadingRows,
                    staticTables,
                    true,
                    selectedStandardIds,
                    fileAttachment,
                    witnessDetails
                  )
                }
              />
            </>
          )}
      </div>
        <div className="flex justify-end">
          <AddButton
            id="btn-add-Send-For-Approval"
            label="Send For Approval"
            onClick={() =>
              sendForApproval(datasheetDetails1?.id, datasheetDetails1)
            }
            className=" disabled:opacity-50"
            disabled={datasheetDetails?.observationSheet_requestApproval == 1}
          />
        </div>
      </div>
    </div>
  );
};

export default function EditDatasheet(props) {
  const contextValue = useCreateReducer({
    initialState,
  });
  return (
    <DatasheetContext.Provider value={{ ...contextValue }}>
      <DatasheetForm {...props} />
    </DatasheetContext.Provider>
  );
}
